export const environment = {
  production: false,
  demo: false,
  showEesztIdentifiers: true, // accreditation: show EESZT user/NNGYK6/NNGYK9 ids in the navbar
  name: 'nautopsy-dev',
  apiUrl: 'https://bck-teszt.nautopsy.hu',
  eszigReaderUrl: '', // TODO: add topsy development eszig reader url
  logoUrl: 'images/nautopsy_logo_04-02-05.png',
  navbarLogoUrl: 'images/nautopsy_navbar_logo.png',
  printLogoUrl: 'images/nautopsy_print_logo.png'
};

